module.exports = __webpack_public_path__ + "img/0xB3FB48bF090bEDFF4f6F93FFb40221742E107db7.708291f9.png";